import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { LocaleService } from '@next/core-lib/i18n';
import { SiteActions, SiteState } from '@next/core-lib/site';
import { WindowServiceInjector, WindowService } from '@next/core-lib/window';
import { Store, select } from '@ngrx/store';
import { ReplaySubject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { getFertilizationLegalStandards } from './store/legal-standard.actions';
import * as LegalStandardSelectors from './store/legal-standard.selectors';
import { selectFertilizationSettings } from '../advice/store/selectors';
import { getCropYear, selectCropFieldAdvices } from '../store/selectors';

@Component({
  selector: 'app-fertilization-legal-standards-quick-view',
  templateUrl: './fertilization-legal-standards-quick-view.component.html',
  standalone: false,
})
export class FertilizationLegalStandardsQuickViewComponent implements OnInit, OnDestroy {
  private readonly store = inject<Store<SiteState>>(Store);
  private readonly window = inject<WindowService>(WindowServiceInjector);
  private readonly locale = inject(LocaleService);

  destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  readonly reportTitle = this.locale.translate('fertilizationLegalStandardsReportTitle');
  cropYear$ = this.store.pipe(select(getCropYear));
  legalStandardBalance$ = this.store.pipe(
    select(LegalStandardSelectors.selectLegalStandardBalance),
  );
  cropFieldAdvices$ = this.store.pipe(select(selectCropFieldAdvices));
  fertilizationSettings$ = this.store.pipe(select(selectFertilizationSettings));

  pageTitle$ = this.store.pipe(
    select(
      LegalStandardSelectors.selectFertilizationLegalStandardsReportTitle({
        reportTitle: this.reportTitle,
      }),
    ),
  );

  ngOnInit() {
    this.pageTitle$.pipe(takeUntil(this.destroyed$)).subscribe((pageTitle) => {
      this.store.dispatch(SiteActions.updatePageTitle({ pageTitle }));
    });

    combineLatest([this.cropFieldAdvices$, this.fertilizationSettings$, this.legalStandardBalance$])
      .pipe(takeUntil(this.destroyed$))
      .subscribe(([cropFieldAdvices, fertilizationSettings, legalStandardBalance]) => {
        if (cropFieldAdvices && fertilizationSettings && !legalStandardBalance) {
          this.store.dispatch(getFertilizationLegalStandards());
        }
      });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  print() {
    this.window.print();
  }
}
